import app from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/storage";
import "firebase/compat/app-check"; //
// import {connect} from 'react-redux';

// import sushimaster from './sushimaster.json';
// import yasumaki from './yasumaki.json';

class Firebase {
	constructor(props) {
		const { appCheckRecaptchaKey, ...firebaseConfig } = props.config;

		//let data = require(`./${login}.json`);
		app.initializeApp(firebaseConfig);

		// window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;

		if (appCheckRecaptchaKey) {
			const appCheck = app.appCheck();

			appCheck.activate(
				new app.appCheck.ReCaptchaEnterpriseProvider(appCheckRecaptchaKey),
				true // enableAutoRefresh
			);
		}
		this.auth = app.auth();
		this.bd = app.database();
		this.storage = app.storage();
		this.deleteSessions = () => {
			app.app().delete();
		};
	}

	doSignInWithEmailAndPassword = (email, password) =>
		this.auth.signInWithEmailAndPassword(email, password);

	doSignOut = () => {
		this.auth.signOut();
		this.deleteSessions();
	};
}

export default Firebase;
